import * as api from '@/api/task'
import { task } from '@/store/mutation-type'

Object.deepAssign = function (target, varArgs) {
    'use strict'
    if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object')
    }
    let to = Object(target)
    for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index]
        if (nextSource != null) {
            for (let nextKey in nextSource) {
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    if (Object.prototype.toString.call(nextSource[nextKey]).indexOf('Object') === 8) {
                        to[nextKey] = to[nextKey] || {}
                        Object.deepAssign(to[nextKey], nextSource[nextKey])
                    } else {
                        to[nextKey] = nextSource[nextKey]
                    }
                }
            }
        }
    }
    return to
}

const state = {
    showNewUserReward: false,
    experObj: null,
    layerTreasureObj: null,
    userInfo: null,
    helpInfo: null,
    layerObj: null,
    allTasks: {},
    typeTasks: {},
    typeList: [],
    chestList: []
}

const getters = {
    [task.ALLCOMPLETE]: function (state, type, rootState) {
        let allComplete = true
        if (state.typeTasks[rootState.route.params.type]) {
            state.typeTasks[rootState.route.params.type].forEach(function (element, index) {
                if (element.btn && element.btn.status === 'TASKING') {
                    allComplete = false
                }
            })
        }
        return allComplete
    },
    [task.TASKLISTS]: function (state, type, rootState) {
        return state.typeTasks[rootState.route.params.type]
    },
    [task.HELPLISTS]: function (state, type, rootState) {
        return state.typeTasks[rootState.route.params.type]
    },
    [task.USERINFO]: function (state) {
        return state.userInfo
    },
    [task.TYPELISTS]: function (state, type, rootState) {
        let _array = []
        state.typeList.forEach(function (element) {
            element.hasNewLength = 0;
            (state.typeTasks[element.type] || []).forEach(function (_element) {
                /**
                 * 个性化数据 日常任务受宝箱数据影响
                 */
                if (element.type === 'DAILY' && state.chestList) {
                    state.chestList.forEach(function (__element) {
                        if (state.userInfo.star >= __element.star && !__element.opened) {
                            element.hasNewLength++
                        }
                    })
                }
                /**
                 * 检测是否有未领取内容
                 */
                if (_element.btn && _element.btn.status === 'COMPLETE') {
                    element.hasNewLength++
                }
            })
            _array.push(element)
        })
        return _array
    },
    [task.HELPINFO]: function (state) {
        return state.helpInfo
    }
}

const actions = {
    [task.TREASURELEVEL]: ({ commit }, obj) => {
        commit(task.TREASURELEVEL, {
            data: obj
        })
    },
    [task.LAYER]: ({ state, commit, rootState }, code) => {
        commit(task.LAYER, state.allTasks[code])
    },
    [task.TASKLISTS]: ({ commit, dispatch }) => {
        api.listData({}, (_data) => {
            commit(task.USERINFO, {
                data: _data.userInfo
            })
            commit(task.TYPELISTS, {
                data: _data.typeList
            })
            commit(task.CHESTLIST, {
                data: _data.chest
            })
            commit(task.TASKLISTS, {
                data: {
                    allTasks: _data.allTasks,
                    typeTasks: _data.typeTasks
                }
            })
            commit(task.ADDS, {
                data: _data.showNewUserReward
            })
        }, (_data) => dispatch('ERROR_MESSAGE', _data.ret_msg))
    },
    [task.TASKLISTS_BY_TYPE]: ({ commit, dispatch }, type) => {
        api.listData({}, (_data) => {
            commit(task.TASKLISTS, {
                type: 'sList',
                tType: type,
                data: _data.typeTasks[type]
            })
        }, (_data) => dispatch('ERROR_MESSAGE', _data.ret_msg))
    },
    [task.HELPLISTS]: ({ rootState, commit, dispatch }) => {
        api.helpData({
            module: rootState.route.params.module,
            ruleType: rootState.route.params.module === 'coins' ? 'COINS_RULE' : 'GROWTH_RULE'
        }, (_data) => {
            commit(task.HELPINFO, {
                data: _data.helpInfo
            })
            commit(task.TYPELISTS, {
                data: _data.typeList
            })
            commit(task.TASKLISTS, {
                data: {
                    allTasks: _data.allTasks,
                    typeTasks: _data.typeTasks
                }
            })
        }, (_data) => dispatch('ERROR_MESSAGE', _data.ret_msg))
    },
    [task.EXPERIENCE]: ({ state, commit, rootState, dispatch }, code) => {
        api.exper({
            taskCode: code,
            id: state.allTasks[code].id
        }, (_data) => {
            // 用户数据同步
            commit(task.USERINFO, {
                type: 'change',
                data: {
                    coins: state.userInfo.coins + _data.coinsValue,
                    growth: state.userInfo.growth + _data.growthValue,
                    level: _data.level,
                    star: state.userInfo.star + (_data.starValue || 0),
                    growthEnd: state.userInfo.growth + _data.growthValue + _data.upNeedGrowth
                }
            })
            // 动画效果 + 按钮同步
            commit(task.TASKLISTS, {
                code: code,
                type: 'simple',
                data: {
                    addExper: {
                        coins: _data.coinsValue,
                        growth: _data.growthValue
                    },
                    btn: {
                        status: 'RECEIVE'
                    }
                }
            })
            setTimeout(() => {
                commit(task.TASKLISTS, {
                    code: code,
                    type: 'simple',
                    data: {
                        addExper: null,
                        show: !state.allTasks[code].hasNextTask
                    }
                })
                // 同步成就
                dispatch(task.TASKLISTS_BY_TYPE, 'ACHIEVEMENT')
            }, 2000)
        }, (_data) => {
            if (_data.ret_code === 10001) {
                commit(task.TASKLISTS, {
                    code: code,
                    type: 'simple',
                    data: {
                        show: false
                    }
                })
            } else if (_data.ret_code === 10002) {
                commit(task.TASKLISTS, {
                    code: code,
                    type: 'simple',
                    data: {
                        btn: {
                            status: 'RECEIVE'
                        }
                    }
                })
            }
            dispatch('ERROR_MESSAGE', _data.ret_msg)
        })
    },
    [task.EXPERLAYER]: ({ state, commit, dispatch }, obj) => {
        // 同步用户数据
        commit(task.USERINFO, {
            type: 'change',
            data: {
                coins: state.userInfo.coins + obj.levelCoinsValue,
                growth: state.userInfo.growth + obj.levelGrowthValue,
                level: obj.level,
                growthEnd: state.userInfo.growth + obj.levelGrowthValue + obj.upNeedGrowth
            }
        })
        // 动画
        commit(task.EXPERLAYER, {
            data: {
                levelGrowthValue: obj.levelGrowthValue,
                levelCoinsValue: obj.levelCoinsValue,
                top: obj.target.getBoundingClientRect().top,
                left: obj.target.getBoundingClientRect().left
            }
        })
        setTimeout(() => {
            commit(task.EXPERLAYER, { data: null })
        }, 2000)

        // 同步成就数据
        dispatch(task.TASKLISTS_BY_TYPE, 'ACHIEVEMENT')
    }
}

const mutations = {
    [task.EXPERLAYER]: (state, options) => {
        state.experObj = options.data
    },
    [task.ADDS]: (state, options) => {
        state.showNewUserReward = options.data
    },
    [task.TREASURELEVEL]: (state, options) => {
        // console.log(6)
        state.layerTreasureObj = options.data
        // console.log(options.data)
    },
    [task.LAYER]: (state, _data) => {
        state.layerObj = _data
    },
    [task.HELPINFO]: (state, options) => {
        state.helpInfo = options.data
    },
    [task.TASKLISTS]: (state, options) => {
        switch (options.type) {
            case 'delete':
                state.typeTasks[state.allTasks[options.code].type] = state.typeTasks[state.allTasks[options.code].type].filter(function (element) {
                    return element.code !== options.code
                })
                delete state.allTasks[options.code]
                return
            case 'simple':
                Object.deepAssign(state.allTasks[options.code], options.data)
                return
            case 'sList':
                state.typeTasks[options.tType] = options.data
                options.data.forEach((element) => {
                    state.allTasks[element.code] = element
                })
                return
            default:
                state.allTasks = options.data.allTasks
                state.typeTasks = options.data.typeTasks
                return
        }
    },
    [task.USERINFO]: (state, options) => {
        switch (options.type) {
            case 'change':
                Object.deepAssign(state.userInfo, options.data)
                return
            default:
                state.userInfo = options.data
                return
        }
    },
    [task.CHESTLIST]: (state, options) => {
        switch (options.type) {
            case 'simple':
                Object.deepAssign(state.chestList[options.index], options.data)
                return
            default:
                state.chestList = options.data
                return
        }
    },
    [task.TYPELISTS]: (state, options) => {
        state.typeList = options.data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js